import React from 'react';
import { useGetProductReviewsQuery } from '../features/review/reviewsApiSlice';
import ProductReview from './ProductReview';
import AddReview from './AddReview';

const ProductReviewList = ({ productId, need }) => {
  const {
    data: productReviews,
    isSuccess,
    isError,
    error,
    refetch
  } = useGetProductReviewsQuery(productId);

  if (isError) {
    console.error(error);
    return (
      <div className="p-4 text-red-500">
        Failed to load {need === "Sell" ? "comments" : "offers"}
      </div>
    );
  }

  if (!isSuccess) return null;

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">
          {productReviews?.totalCount} {need === "Sell" ? "Comments" : "Offers"}
        </h2>
      </div>

      <AddReview
        productId={productId}
        need={need}
        useFor="comment"
        refetch={refetch}
      />

      <div className="mt-8 space-y-6">
        {productReviews?.data?.length > 0 ? (
          productReviews.data.map((productReview) => (
            <div key={productReview?._id} className="border-b border-gray-200 last:border-0 pb-6 last:pb-0">
              <ProductReview
                productId={productId}
                need={need}
                productReview={productReview}
                refetch={refetch}
              />
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center py-4">
            No {need === "Sell" ? "comments" : "offers"} yet. Be the first to add one!
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductReviewList;